// ErrorState — generic error / retry placeholder
// Session 3

import React from 'react';

interface Props {
  message?: string;
  onRetry?: () => void;
}

export function ErrorState({ message = 'Something went wrong', onRetry }: Props) {
  return (
    <div style={wrapStyle}>
      <div style={iconWrap}>
        <AlertIcon />
      </div>
      <p style={headingStyle}>{message}</p>
      {onRetry && (
        <button onClick={onRetry} style={retryStyle}>
          Try again
        </button>
      )}
    </div>
  );
}

function AlertIcon() {
  return (
    <svg width={28} height={28} viewBox="0 0 24 24" fill="none" stroke="#ef4444" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10" />
      <line x1="12" y1="8" x2="12" y2="12" />
      <line x1="12" y1="16" x2="12.01" y2="16" />
    </svg>
  );
}

const wrapStyle: React.CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: '60px 24px',
  textAlign: 'center',
};

const iconWrap: React.CSSProperties = {
  width: 56,
  height: 56,
  borderRadius: '50%',
  background: '#ef44441a',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginBottom: 16,
};

const headingStyle: React.CSSProperties = {
  fontSize: 14,
  color: 'var(--text-muted)',
  marginBottom: 4,
};

const retryStyle: React.CSSProperties = {
  marginTop: 12,
  padding: '8px 18px',
  borderRadius: 100,
  background: 'var(--surface2)',
  color: 'var(--text)',
  fontSize: 13,
  fontWeight: 600,
  cursor: 'pointer',
};
